import { useContext, useState, useEffect } from 'react';

import { BettingConfigCtx } from 'root/bettingConfigCtx';
import { BettingWidgets, BettingWidgetsOptions } from 'types';

interface Input<T extends BettingWidgets> {
    widget: T;
}

type Output<T extends BettingWidgets> = BettingWidgetsOptions[T];

function useWidgetSettings<T extends BettingWidgets>({
    widget,
}: Input<T>): Output<T> {
    const { widgets$ } = useContext(BettingConfigCtx);
    const [widgetOptions, changeWidgetOptions] = useState<Output<T>>(
        widgets$.getValue()[widget]
    );

    useEffect(() => {
        const sub = widgets$.subscribe(widgetsOptions =>
            changeWidgetOptions(widgetsOptions[widget])
        );

        return () => sub.unsubscribe();
    }, [widgets$, widget]);

    return widgetOptions;
}

export default useWidgetSettings;
